import { ecbrRequest } from '../../request/ecbrRequest'
import { objectToQueryString } from '../../../utils/objectToQueryString'
import { AdminRoles } from '../../../constants/roles'

export const users = {
  getAll: async (params) => ecbrRequest.get('/admin/users', { params }),
  getAllECBRAdmins: async (params) =>
    ecbrRequest.get(
      `/admin/users${objectToQueryString({
        ...params,
        roles: AdminRoles
      })}`
    ),
  getById: async (id) => ecbrRequest.get(`/admin/users/${id}`),
  create: async (user) => ecbrRequest.post('/admin/users', user),
  update: async (id, user) => ecbrRequest.put(`/admin/users/${id}`, user),
  delete: async (id) => ecbrRequest.delete(`/admin/users/${id}`),
  deactivate: async (id) =>
    ecbrRequest.put(`/admin/users/${id}`, { active: false }),
  activate: async (id) =>
    ecbrRequest.put(`/admin/users/${id}`, { active: true }),
  auth: async () => ecbrRequest.get('/admin/users/auth'),
  getCompanyUsers: async (params) =>
    ecbrRequest.get('/company/users', { params }),
  updateCompanyUser: async (id, user) =>
    ecbrRequest.put(`/company/users/${id}`, user),
  getCompanyUserById: async (id) => ecbrRequest.get(`/company/users/${id}`),
  activateCompanyUser: async (id) =>
    ecbrRequest.patch(`/company/users/activate/${id}`),
  deactivateCompanyUser: async (id) =>
    ecbrRequest.patch(`/company/users/deactivate/${id}`),
  existsByEmail: async (email) =>
    ecbrRequest.get(`/company/users/exists?key=email&value=${email}`)
}
